import i18n from '../../i18n';
import Color from 'color'
import Event from 'components/agenda/Event'
import NewEventsList from 'components/agenda/NewEventsList'
import Toolbar from 'components/agenda/Toolbar'
import moment from 'moment'
import 'moment/locale/nl'
import React from 'react'
import BigCalendar from 'react-big-calendar'
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop'
import { DragDropContext } from 'react-dnd'

import html5Backend from 'react-dnd-html5-backend'
import ui from 'redux-ui'
import { Segment } from 'semantic-ui-react'

// Setup the localizer by providing the moment (or globalize) Object
// to the correct localizer.
moment.locale(i18n.locale);
moment.locale('nl');
BigCalendar.momentLocalizer(moment); // or globalizeLocalizer

const components = {
  event: Event,
  toolbar: Toolbar
}

const DragAndDropCalendar = withDragAndDrop(BigCalendar, {backend: false}) // Provide an own shared backend


class EventsCalendar extends React.Component {
  componentDidUpdate(prevProps) {
    if (( prevProps.ui.date !== this.props.ui.date) || ( prevProps.ui.view !== this.props.ui.view)) {
      this.filter(this.props.ui.date, this.props.ui.view);
    }
  }

  handleNavigate(date, view , action) {
    this.props.updateUI("date", date.toISOString())
    this.props.updateUI("view", view)
    this.filter(date, view)
  }

  filter(date, view) {
    let startTime = moment(date).startOf(view).toISOString()
    let endTime = moment(date).endOf(view).toISOString()
    this.props.fetchEvents(startTime, endTime);
    this.props.fetchConsultations(startTime, endTime)
  }

  handleView(view) {
    this.props.updateUI('view', view)
    this.filter(this.props.ui.date, view)
  }

  onSelect(event) {
    this.props.updateUI('eventOpen', event.id)
  }

  eventStyleGetter = (event, start, end, isSelected) => {
    var backgroundColor = event.displayColor;
    var fontColor = Color(backgroundColor).isDark() ?  'white' : 'black';
    var style = {
      backgroundColor: backgroundColor,//  backgroundColor,
      borderColor: 'white',
      color: fontColor,
      borderRadius: '5px',
      opacity: event.markedForRemoval ? 0.1 : 0.8,
      display: 'block'
    };
    return {
      style: style
    };
  }

  render () {
    return (
      <div>
        { this.props.ui.isNewEventsListVisible ?
        <NewEventsList/> : null
        }
        <Segment clearing basic loading={this.props.loading}>
          <DragAndDropCalendar
            events={this.props.events}
            messages={I18n.t('components.big_calendar')}
            culture={i18n.locale}
            startAccessor='startTime'
            endAccessor='endTime'
            titleAccessor='summary'
            onNavigate={(date,view,action) => this.handleNavigate(date, view,action) }
            onEventDrop={this.props.acceptEvent}
            onView={(view) => this.handleView(view) }
            date={new Date(this.props.ui.date) || new Date()}
            view={this.props.ui.view}
            defaultView={'week'}
            min={new Date(2018,1,1,8,0,0)}
            max={new Date(2018,1,1,23,0,0)}
            eventPropGetter={this.eventStyleGetter}
            onSelectEvent = {(event) =>this.onSelect(event)}
            popup
            selectable
            views={['day','week','month']}
            components={components}
          />
        </Segment>
      </div>
    )
  }
}


export default ui({ key: 'eventsCalendar',  state: {eventOpen: null, isNewEventsListVisible: false, date: (new Date()).toISOString(), view: 'week'  } })(DragDropContext(html5Backend)(EventsCalendar));
